import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';
import { ContactForm } from '../contact/ContactForm.js';
import { WhatHappensNext } from '../contact/WhatHappensNext.js';

export function Offers() {
  const { t } = useTranslation(['offers']);

  return (
    <section className="offers">
      <div className="offers__grid">
        {profile.offers.map((offer) => (
          <article key={offer.id} className={`offer${offer.featured ? ' offer--featured' : ''}`}>
            <div className="offer__eyebrow">{t(`offers:${offer.id}.eyebrow`)}</div>
            <h3 className="offer__title">{t(`offers:${offer.id}.title`)}</h3>
            <p className="offer__text">{t(`offers:${offer.id}.body`)}</p>
            <div className="offer__terms">{t(`offers:${offer.id}.terms`)}</div>
          </article>
        ))}
      </div>

      <div className="contact">
        <ContactForm />
        <WhatHappensNext />
      </div>
    </section>
  );
}
